// @flow strict
// schema.org structure for address can be found here:
// https://schema.org/address

import * as React from 'react';
import type { BusinessNumberType, TelephoneType } from '../types';
import type { AddressType } from '../../../../internal/Address';
import Address from '../../../../internal/Address';
import styles from './styles.scss';
import { Link } from '../../../../internal/Button';

type PropTypes = {|
  address: AddressType,
  telephoneNumber: TelephoneType,
  businessNumber?: BusinessNumberType,
  className?: string,
|};

const Phone = ({ phone }: { phone: string }) => (
  <span>
    Tel:{' '}
    <Link href={`tel: ${phone}`} itemProp="telephone" variant="Link">
      {phone}
    </Link>
  </span>
);

const BusinessNumber = ({ businessNumber }: { businessNumber: string }) => (
  <span itemProp="taxID" className={styles.businessNumber}>
    {businessNumber}
  </span>
);

export default (props: PropTypes) => (
  <address itemScope itemType="http://schema.org/Organization" className={props.className}>
    <span className={styles.organisation} itemProp="name">
      Ansarada
    </span>
    <Address address={props.address} className={styles.address} />
    {props.businessNumber && <BusinessNumber businessNumber={props.businessNumber} />}
    <Phone phone={props.telephoneNumber} />
  </address>
);
